import { Builder } from "@builder.io/react";
import Banner from ".";

const HomeBanner = () => <Banner />;
Builder.registerComponent(HomeBanner, {
    name: "HomeBanner",
});
